import { Story } from '@app/components/Risk/types'
import { sanitizeStories } from '@app/components/Risk/types/RiskStory'
import apiClient from '@app/config/axios.config'
import { Endpoint } from '@app/config/endpoints'
import { storiesAtom } from '@app/state/storiesAtom'
import { atom } from 'jotai'

export const fetchStories = async (): Promise<Story[]> => {
  const { data } = await apiClient.get<unknown[]>(`${Endpoint.getStories}`)
  // Validate and sanitize using zod
  const result = sanitizeStories(data)
  return result
}

export const selectedStoryIdAtom = atom<number | null>(null)

export const selectedStoryAtom = atom((get) => {
  const storiesQuery = get(storiesAtom)
  const selectedId = get(selectedStoryIdAtom)

  if (!storiesQuery?.data || selectedId === null) return null
  return storiesQuery.data.find((s) => s.id === selectedId) ?? new Error('Not found')
})
